import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  viewChild
} from '@angular/core';
import { TranslationModule } from 'src/app/i18n';

import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-modal-title',
    imports: [CommonModule, TranslationModule, MatTooltipModule],
    templateUrl: './modal-title.component.html'
})
export class ModalTitleComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() isShowClose: boolean = false;

  @Output() isCloseModal = new EventEmitter<boolean>();

  hasContent = false;
  readonly headerContent = viewChild<ElementRef>('headerContent');

  ngAfterContentInit() {
    this.hasContent = !!this.headerContent()?.nativeElement?.childNodes?.length;
  }

  /** close modal*/
  onClose() {
    this.isCloseModal.emit(true);
  }
}
